module.exports = "/_next/static/images/recro-c6a4e77797f82742b146a80e5a595592.png";